<template>
  <div v-if="advertise">
    <categories v-model="category"></categories>

    <div class="col-md-8 mx-auto px-0">
      <city-selector :defaultEdit="true" :editCity="advertise.location" ref="city" :force="true"></city-selector>
    </div>

    <div class="col-md-8 pt-0 mx-auto px-0" v-if="type==='advertise'">
      <number-selector ref="number" :key="token" :editNum="advertise.contact.phone" :force="true" :multiple-numbers="false"></number-selector>
    </div>

    <div class="col-md-8 pt-0 mx-auto px-0">
      <pic-selector :is_edit="true" :editImg="advertise.images"></pic-selector>
    </div>

    <div class="col-md-8 pt-0 mx-auto px-0">
      <CallMethod v-if="['shoes-belt-bag','clothing-and-shoes','clothing'].indexOf(category.slug)> -1" v-model="advertise.contact.call_method"></CallMethod>
    </div>

    <div class="px-5 mx-1 pt-0">
      <inputs ref="inputs" :type="type" :fields="fields" :advertise="advertise"></inputs>
    </div>

    <setting-ads :edit-mode="advertise.contact" class="pr-5"></setting-ads>

    <div class="col-md-8 d-flex justify-content-end mr-auto">
      <v-btn type="submit" class="submit-btn" elevation="8" @click="checkTitle">
        <span class="fa fa-save pr-1" style="font-size: 1.3rem"></span>
        بروزرسانی آگهی
      </v-btn>
    </div>
  </div>
</template>

<script>
import CategorySelector from "../categorySelector";
import Categories from "./Categories";
import CitySelector from "../citySelector";
import NumberSelector from "../numberSelector";
import PicSelector from "../../uploadCenter/picSelector";
import SettingAds from "../settingAds";
import InputMaker from "../inputMaker";
import Inputs from "./Inputs";
import {Bus} from "../../../../main";
import CallMethod from "./CallMethod";

export default {
  name: "EditAdvertise",
  components: {CallMethod, Inputs, InputMaker, SettingAds, PicSelector, NumberSelector, CitySelector, Categories, CategorySelector},
  props: {
    token: {
      required: true,
    },
    modal: {
      required: true
    },
    type: {
      required: true,
      default: "advertise"
    }
  },
  data() {
    return {
      advertise: null,
      category: null,
      fields: null,
      available_at: null,
      expire_at: null,
    }
  },
  methods: {
    getData() {
      if (this.type === "advertise")
        this.getAdvertiseDetail();
      else
        this.getDefaultDetail();
    },
    getAdvertiseDetail() {
      $.ajax({
        url: `${url}/advertise/post/${this.token}`,
        type: 'GET',
        fn: this.getAdvertiseDetail,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        success: (response) => {
          this.advertise = response.data;

          this.category = {
            slug: response.data.category
          }

          this.setWatchForAdvertise();
        }
      });
    },
    getDefaultDetail() {
      $.ajax({
        url: `${url}/default/${this.token}`,
        type: 'GET',
        fn: this.getDefaultDetail,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token
        },
        success: (response) => {
          this.advertise = response.data.data.advertise;

          this.category = {
            slug: response.data.data.advertise.category
          }

          this.setWatchForAdvertise();
        }
      });

    },
    getDependencies(category) {
      $.ajax(
          {
            url: `${url}/divar/categories/${category}/dependency`,
            method: 'POST',
            dataType: 'json',
            async: false,
            data: JSON.stringify(this.advertise),
            fn: this.getDependencies,
            params: [category],
            headers: {
              'Authorization': Token,
              "Content-Type": "application/json",
              "ACCEPT": "application/json",
            },
            success: (response) => {
              this.fields = response.data;
            }
          }
      )
    },
    setWatchForAdvertise() {
      Object.keys(this.advertise).forEach(key => {
        this.$watch(`advertise.${key}`, function (newValue, OldValue) {
          if (!newValue)
            return;

          const filed = this.fields.find(item => item.name === key);

          if (filed.auto_refresh)
            this.getDependencies(this.category.slug);
        })
      });
    },
    deleteUnnecessaryFields() {
      let data = {};

      Object.keys(this.advertise).forEach(key => {
        const field = this.fields.find(item => item.name === key);

        if (field || key === "contact") {
          data[key] = this.advertise[key];
        }
      });

      return data;
    },
    checkTitle() {
      if (!this.$refs.inputs.validate() || (!this.$refs?.number?.validate() && this.type === "advertise") || !this.$refs.city.validate())
        return;

      this.$modal.showLoading();

      $.ajax({
        url: `${url}/divar/check/title`,
        type: "POST",
        fn: this.checkTitle,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": 'application/json'
        },
        data: JSON.stringify({
          "title": this.advertise['title'],
          "city": String(this.advertise.location.city),
          "category": this.advertise.category
        }),
        msg: false,
        error: (data) => {
          if (data.status === 422) {
            this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.');
          } else {
            this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
          }
        },
        success: () => {
          this.$modal.hideLoading();

          if (this.type === "advertise")
            this.submitAdvertise();
          else
            this.submitDefault();
        }
      });

    },
    submitAdvertise() {
      let data = {
        advertise: this.deleteUnnecessaryFields(),
        available_at: this.available_at,
        expire_at: this.expire_at,
        auto_pay: this.advertise.contact.autoPay,
      };

      delete data.advertise.contact.autoPay

      if (data.available_at === "" || !data.available_at) {
        delete data.available_at;
      }

      if (data.expire_at === "" || !data.expire_at) {
        delete data.expire_at;
      }

      $.ajax({
        url: `${url}/divar/advertise/update/${this.token}`,
        method: 'PUT',
        fn: this.updateAds,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Token,
          ACCEPT: 'application/json'
        },
        msg: true,
        data: JSON.stringify(data),
        success: () => {
          this.advertise = [];
          this.modal();
        },
      })
    },
    submitDefault() {
      let data = {
        advertise: this.deleteUnnecessaryFields(),
        available_at: this.available_at,
        expire_at: this.expire_at,
        auto_pay: this.advertise?.contact?.auto_pay,
      };

      delete data.advertise?.contact?.auto_pay

      // if (data.available_at === "" || !data.available_at)
      //     delete data.available_at;
      //
      // if (data.expire_at === "" || !data.expire_at)
      //     delete data.expire_at;

      $.ajax({
        url: `${url}/default/${this.token}`,
        method: 'PUT',
        fn: this.submitDefault,
        msg: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Token,
          ACCEPT: 'application/json'
        },
        data: JSON.stringify({data: data}),
        success: () => {
          // this.advertise = [];
          // this.modal();
        }
      })
    }
  },
  watch: {
    token() {
      this.getData();
    },
    category(newValue, oldValue) {
      if (newValue.slug !== oldValue?.slug)
        this.getDependencies(newValue.slug);
    }
  },
  mounted() {
    this.getData();

    Bus.$on('times', (value) => {
      this.available_at = value.times.starttime;
      this.expire_at = value.times.endtime;
    });

    Bus.$on('cityInfo', (value) => {
      this.advertise.location.neighborhood = value.neighborhood
    });
  }
}
</script>

<style scoped>

</style>